import { Box, Paper, Skeleton } from '@mui/material';

export const ProfileSkeleton = () => {
  return (
    <Box>
      <Paper
        elevation={0}
        sx={{
          p: { xs: 3, sm: 4 },
          borderRadius: 1.5,
          border: '1px solid',
          borderColor: 'divider',
          overflow: 'hidden',
        }}
      >
        {/* Avatar Section Skeleton — mirrors AvatarSection's centered avatar + name/caption, mb:6 */}
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 6 }}>
          <Skeleton
            variant="circular"
            width={120}
            height={120}
            animation="wave"
            sx={{ width: { xs: 100, sm: 120 }, height: { xs: 100, sm: 120 } }}
          />
          <Box
            sx={{
              mt: 2.5,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 0.5,
            }}
          >
            <Skeleton variant="text" width={140} height={32} animation="wave" />
            <Skeleton variant="text" width={110} height={20} animation="wave" />
          </Box>
        </Box>

        {/* Profile Form Skeleton — mirrors ProfileFormSection's single-column name/email/phone/save layout */}
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Skeleton variant="text" width={60} height={20} animation="wave" />
          <Skeleton variant="rounded" height={52} sx={{ borderRadius: 2 }} animation="wave" />

          <Skeleton variant="text" width={60} height={20} animation="wave" />
          <Skeleton variant="rounded" height={52} sx={{ borderRadius: 2 }} animation="wave" />
          <Skeleton variant="text" width={200} height={16} animation="wave" />

          <Skeleton
            variant="rounded"
            height={44}
            sx={{ mt: 1, borderRadius: 2 }}
            animation="wave"
          />
        </Box>
      </Paper>
    </Box>
  );
};
